/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsSupplierProduct
 */
export interface AssetsMelcoModelsSupplierProduct {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    supplier_id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    supplier_name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    platform_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    publish_state: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    created_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsSupplierProduct
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
}

export function AssetsMelcoModelsSupplierProductFromJSON(json: any): AssetsMelcoModelsSupplierProduct {
    return AssetsMelcoModelsSupplierProductFromJSONTyped(json, false);
}

export function AssetsMelcoModelsSupplierProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsSupplierProduct {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'supplier_id': json['supplier_id'],
        'supplier_name': json['supplier_name'],
        'code': json['code'],
        'platform_id': !exists(json, 'platform_id') ? undefined : json['platform_id'],
        'publish_state': json['publish_state'],
        'created_date': (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
    };
}

export function AssetsMelcoModelsSupplierProductToJSON(value?: AssetsMelcoModelsSupplierProduct | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'code': value.code,
        'platform_id': value.platform_id,
        'publish_state': value.publish_state,
        'created_date': (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
    };
}


